import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// const SameDayBookingIdValue = sessionStorage.getItem("SameDayBookingId");

// Async action to fetch cleaning same day list data
export const getCleaningSameDayList = createAsyncThunk(
  "cleaningSameDayList/getCleaningSameDayList",
  async ({ data, pathname }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cleaning/schedule-cleaning`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            vUniqueCode:
              pathname === "/"
                ? sessionStorage.getItem("SameDayBookingId")
                : sessionStorage.getItem("bookSameDayBookingId"),
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const cleaningSameDaySlice = createSlice({
  name: "cleaningSameDayList",
  initialState: {
    loading: false,
    cleaningSameDayData: null,
    error: null,
  },
  reducers: {
    ResetCleaningSameDayDataState: (state) => {
      state.loading = false;
      state.cleaningSameDayData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCleaningSameDayList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCleaningSameDayList.fulfilled, (state, action) => {
        state.loading = false;
        state.cleaningSameDayData = action.payload;
      })
      .addCase(getCleaningSameDayList.rejected, (state, action) => {
        state.loading = false;
        state.cleaningSameDayData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetCleaningSameDayDataState } = cleaningSameDaySlice.actions;
export default cleaningSameDaySlice.reducer;
